module.exports = __webpack_public_path__ + "static/media/1_nsph_arbetsbok.f5cf05a5.jpg";